var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.smart)?_c('p',{staticClass:"smart"},[_c('span',{attrs:{"data-test-id":"smart-content"}},[_vm._v("\n    "+_vm._s(_vm.truncatedText)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }